// removed by extract-text-webpack-plugin
module.exports = {"vpSubmissionTypeSelectorContainer":"vpSubmissionTypeSelectorContainer___3G24N","vpSelectorSection":"vpSelectorSection___rldWh","vpLabel":"vpLabel___2RFQl","vpRequiredLabel":"vpRequiredLabel___3qdrR","vpOptionsContainer":"vpOptionsContainer___3T_Se","vpOptionCard":"vpOptionCard___1nQSp","vpOptionCardSelected":"vpOptionCardSelected___3utg2","vpErrorMessage":"vpErrorMessage___2U2-D","vpHelpText":"vpHelpText___2nVOD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/SubmissionTypeSelectorField.module.less
// module id = 3817
// module chunks = 33